module.exports = __webpack_public_path__ + "media/images/p-toDoCards/arrow-b94bb7d9c24617b452627915e504f545.svg";